import React, { useState, useEffect } from 'react';

const AdminDashboard = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const currentTheme = localStorage.getItem('theme');
    if (currentTheme) {
      setTheme(currentTheme);
    }
  }, []);

  return (
    <div className="flex flex-col items-center justify-center">

      <div className="w-full relative">
        {isLoading && (
          <div className="absolute inset-0 flex items-center justify-center bg-white dark:bg-gray-800">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          </div>
        )}

        <iframe
          plausible-embed="true"
          src={`https://plausible.io/share/gallery.globe-groupe.com?auth=DOYmW5IKuYXSI-Xs9enBe&embed=true&theme=${theme}`}
          scrolling="no"
          frameBorder="0"
          loading="lazy"
          className="w-full h-[2200px]"
          title="Plausible Analytics"
          onLoad={() => setIsLoading(false)}
        />
        <script async src="https://plausible.io/js/embed.host.js"></script>
      </div>
    </div>
  );
};

export default AdminDashboard;